import { Video, Mail, Globe, FileText, Share2, Film, BookOpen, File } from 'lucide-preact';
import { BRAND_CLASSES } from '@/constants/theme';
export const ASSET_TYPE_META = {
    'Animated Promotional Video': { Icon: Video, color: BRAND_CLASSES.ACCENT.VIOLET, badgeBg: 'bg-violet-100 dark:bg-violet-900/30' },
    'Landing Page': { Icon: Globe, color: BRAND_CLASSES.ACCENT.TEAL, badgeBg: 'bg-teal-100 dark:bg-teal-900/30' },
    'LinkedIn Asset': { Icon: Share2, color: BRAND_CLASSES.ACCENT.BLUE, badgeBg: 'bg-blue-100 dark:bg-blue-900/30' },
    'LinkedIn Event Asset': { Icon: Share2, color: BRAND_CLASSES.ACCENT.BLUE, badgeBg: 'bg-blue-100 dark:bg-blue-900/30' },
    'Slide Deck': { Icon: FileText, color: BRAND_CLASSES.ACCENT.AMBER, badgeBg: 'bg-amber-100 dark:bg-amber-900/30' },
    'Webinar Recording': { Icon: Video, color: BRAND_CLASSES.ACCENT.VIOLET, badgeBg: 'bg-violet-100 dark:bg-violet-900/30' },
    'Highlight Snippet': { Icon: Film, color: BRAND_CLASSES.ACCENT.RED, badgeBg: 'bg-red-100 dark:bg-red-900/30' },
    'Lead Magnet': { Icon: FileText, color: BRAND_CLASSES.ACCENT.AMBER, badgeBg: 'bg-amber-100 dark:bg-amber-900/30' },
    'Email Copy': { Icon: Mail, color: BRAND_CLASSES.ACCENT.INDIGO, badgeBg: 'bg-indigo-100 dark:bg-indigo-900/30' },
    'Email Template': { Icon: Mail, color: BRAND_CLASSES.ACCENT.PURPLE, badgeBg: 'bg-purple-100 dark:bg-purple-900/30' },
    'Case Study': { Icon: BookOpen, color: BRAND_CLASSES.ACCENT.TEAL, badgeBg: 'bg-teal-100 dark:bg-teal-900/30' },
    'Other': { Icon: File, color: BRAND_CLASSES.ACCENT.SLATE, badgeBg: 'bg-slate-100 dark:bg-slate-700/50' },
};
export const DEFAULT_ASSET_META = { Icon: File, color: BRAND_CLASSES.ACCENT.SLATE, badgeBg: 'bg-slate-100 dark:bg-slate-700/50' };
/** Asset types that support the Webster builder overlay */
export const WEBSTER_ASSET_TYPES = ['Landing Page', 'Email Template', 'Email Copy'];
export function isWebsterAssetType(type) {
    return WEBSTER_ASSET_TYPES.includes(type);
}
export const ASSET_STATUS_COLORS = {
    'Draft': BRAND_CLASSES.STATUS.DEFAULT,
    'Ready for Sign-Off': BRAND_CLASSES.STATUS.PENDING,
    'Signed Off': BRAND_CLASSES.STATUS.SUCCESS,
    'Feedback Submitted': BRAND_CLASSES.STATUS.DRAFT,
    'Reopened': BRAND_CLASSES.STATUS.INFO,
};
